export enum AudienceCappingType {
  NoCap = 0,
  Fixed = 2,
  Percentage = 4
}
